import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { Resolver, useForm } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect, useState } from "react";
import validaRut from "../../../../utils/validaRut";
import { useToast } from "../../../../hooks/useToast";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import { Dialog, DialogContent, DialogTitle, FormHelperText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { Dominios, EnumTipoEstadoRegistro, StatusCode } from "../../../../utils/enums";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../../services/servicesDominio";
import { selectorTransversal } from "../../../../dtos/selector";
import Validaciones from "../../../../utils/validaciones";
import { Tasa, TasaCrear, TasaEditar, TasaModal } from "../models/tasa";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import { useTasas } from "../hooks/useTasas";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";


interface IProps {
    show: boolean
    datosEditar: TasaEditar | undefined
    onHide: () => void
    refresh: () => void
}


const validationSchema = yup.object({
    valor: yup.number().required('Campo requerido'),
    fechaInicioVigencia: yup
        .date()
        .required('Campo requerido'),
    fechaTerminoVigencia: yup
        .date()
        .required('Campo requerido')
        .min(yup.ref('fechaInicioVigencia'), 'La fecha término debe ser mayor o igual a la fecha inicio'),
    montoDesde: yup
        .number()
        .required('Campo requerido')
        .max(999999999999.9999, 'El monto desde excede el valor máximo'),
    montoHasta: yup
        .number()
        .required('Campo requerido')
        .min(yup.ref('montoDesde'), 'El monto hasta debe ser mayor o igual al monto desde')
        .max(999999999999.9999, 'El monto hasta excede el valor máximo'),
});


const ModalTasa: React.FC<IProps> = ({ show, datosEditar, onHide, refresh }) => {
    const { addToast } = useToast();
    const { save } = useTasas();

    async function onSubmit(data: TasaModal) {
        const response = await save(data, datosEditar);
        if (response.status === StatusCode.NoContent) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: datosEditar ?
                    'Tasa modificada con éxito.' :
                    'Tasa creada con éxito.'
            });

            refresh();
            onHide();
            reset();
        }

    }

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
    } = useForm<TasaModal>({
        resolver: yupResolver(validationSchema) as Resolver<TasaModal>,
        mode: 'onBlur',
    })

    useEffect(() => {
        if (datosEditar && show) {
            setValue('id', datosEditar.id);
            setValue('valor', datosEditar.tasa);
            setValue('fechaInicioVigencia', datosEditar.fechaInicioVigencia);
            setValue('fechaTerminoVigencia', datosEditar.fechaTerminoVigencia);
            setValue('activo', datosEditar.activo);
            setValue('montoDesde', datosEditar.montoDesde);
            setValue('montoHasta', datosEditar.montoHasta);

        } else {
            reset();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datosEditar, show]);


    function customOnHide() {
        reset()
        onHide()
    }

    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {datosEditar ? 'Editar Tasa' : 'Nueva Tasa'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid size={3}>
                            <InputNumber
                                name="valor"
                                control={control}
                                label='Tasa'
                                error={errors.valor}
                                decimales={4}
                            />
                        </Grid>
                        <Grid size={3}>
                            <InputFecha
                                name="fechaInicioVigencia"
                                control={control}
                                label="Fecha Inicio Vigencia"
                                fecha={datosEditar?.fechaInicioVigencia}
                                error={errors.fechaInicioVigencia}
                            />
                        </Grid>
                        <Grid size={3}>
                            <InputFecha
                                name="fechaTerminoVigencia"
                                control={control}
                                label="Fecha Término Vigencia"
                                fecha={datosEditar?.fechaTerminoVigencia}
                                error={errors.fechaTerminoVigencia}

                            />
                        </Grid>
                        <Grid size={3}>
                            <InputNumber name="montoDesde" control={control} label="Monto Desde" error={errors.montoDesde} decimales={4} />
                        </Grid>
                        <Grid size={3}>
                            <InputNumber name="montoHasta" control={control} label="Monto Hasta" error={errors.montoHasta} decimales={4}
                            />
                        </Grid>
                    </Grid>
                </form>
                <Grid container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                    <Grid>
                        <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                    </Grid>
                    <Grid>
                        <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                    </Grid>
                </Grid>

            </DialogContent>
        </Dialog>
    )


}
export default ModalTasa

